export default {
  namespaced: true,
  state: {
    params: null,
    user: {},
    fromType: 0 // 通过哪一个入口进入, 0: 我的页面; 1: 列表页面
  },
  mutations: {
    SET_PARAMS(state, data) {
      state.params = data;
    },
    CLEAR_PARAMS(state) {
      state.params = null;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    CLEAR_USER(state) {
      state.user = {};
    },
    SET_FROM_TYPE(state, data) {
      state.fromType = data;
    }
  },
  actions: {
    setBackParams({ commit }, data) {
      commit('SET_PARAMS', data);
    },
    clearBackParams({ commit }) {
      commit('CLEAR_PARAMS');
    },
    setUser({ commit }, data) {
      commit('SET_USER', data);
    },
    clearUser({ commit }) {
      commit('CLEAR_USER');
    },
    setFromType({ commit }, data) {
      commit('SET_FROM_TYPE', data);
    }
  }
};